export default __webpack_public_path__ + "static/media/layout-grid.10ba35ae.png";